<script setup>
import { watch, shallowRef, defineAsyncComponent } from 'vue';

const props = defineProps({
    name: {
        type: String,
        required: true,
    },
});

const icon = shallowRef();

const loadIcon = (name) => {
    icon.value = defineAsyncComponent(() => import(`../../assets/icons/${name}.svg`));
};

loadIcon(props.name);

watch(
    () => props.name,
    (newValue) => {
        loadIcon(newValue);
    }
);
</script>

<template>
    <component :is="icon" />
</template>
